// extracted by mini-css-extract-plugin
export default {"wrapper":"HttpMonitorUnsubscribe_wrapper__DxT1B","box_wrapper":"HttpMonitorUnsubscribe_box_wrapper__EhaHD","text":"HttpMonitorUnsubscribe_text__3CSlg"};